import { render } from "./DeviceComponent.vue?vue&type=template&id=0195bc11&scoped=true"
import script from "./DeviceComponent.vue?vue&type=script&lang=js"
export * from "./DeviceComponent.vue?vue&type=script&lang=js"

import "./DeviceComponent.vue?vue&type=style&index=0&id=0195bc11&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0195bc11"]])

export default __exports__